let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6rWzC")).then(() => parcelRequire('5zjoc'));